var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 24.6459C7.36659 24.6459 2.79492 20.0634 2.79492 14.4409C2.79492 8.81843 7.36659 4.2251 12.9999 4.2251C14.1591 4.2251 15.2858 4.3876 16.3691 4.72343C16.8024 4.85343 17.0408 5.30843 16.9108 5.74176C16.7808 6.1751 16.3258 6.41343 15.8924 6.28343C14.9716 6.00176 13.9966 5.8501 12.9999 5.8501C8.26576 5.8501 4.41992 9.69593 4.41992 14.4301C4.41992 19.1643 8.26576 23.0101 12.9999 23.0101C17.7341 23.0101 21.5799 19.1643 21.5799 14.4301C21.5799 12.7184 21.0816 11.0718 20.1391 9.66343C19.8899 9.2951 19.9874 8.78593 20.3666 8.53676C20.7349 8.2876 21.2441 8.3851 21.4933 8.76426C22.6199 10.4434 23.2158 12.4043 23.2158 14.4409C23.2049 20.0634 18.6333 24.6459 12.9999 24.6459Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4742 6.57573C17.2467 6.57573 17.0192 6.47823 16.8567 6.29407L13.7258 2.6974C13.4333 2.36157 13.4658 1.84157 13.8017 1.54907C14.1375 1.25657 14.6575 1.28907 14.95 1.6249L18.0808 5.22157C18.3733 5.5574 18.3408 6.0774 18.005 6.3699C17.8642 6.51073 17.6692 6.57573 17.4742 6.57573Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8234 9.24089C13.5742 9.24089 13.3251 9.12172 13.1626 8.90505C12.9026 8.54755 12.9784 8.03839 13.3359 7.76755L16.9867 5.10255C17.3442 4.83172 17.8534 4.91839 18.1242 5.27589C18.3951 5.63339 18.3084 6.14255 17.9509 6.41339L14.3001 9.08922C14.1592 9.19755 13.9967 9.24089 13.8234 9.24089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.2d8c9e560ec72ebbf5de3bdae02a66fb.svg";
export { ForwardRef as ReactComponent };